import {isUndefined} from 'lodash';
import {DateTime, Duration} from 'luxon';
import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {
  RelativeDateTimeFormatsEnum,
  RelativeDateTimeFormatter,
} from '../../../../../libs/shared/ui/src/components/datetime/relativeDateTimeFormatter';
import {VisualConversationTrackerModel} from './inviteParticipantsHelpers';

/*
 * Props.
 */

interface ParticipantTrackerItemStatusProps extends VisualConversationTrackerModel {
  isHighlighted?: boolean;
}

/*
 * Component.
 */

export const ParticipantTrackerItemStatus: FC<ParticipantTrackerItemStatusProps> = (props) => {
  const shouldShowUnreadForSubscribers = (!props.hasSeenAll || !props.seenAt) && !props.hasMuted;
  const shouldShowUnreadForNonsubscribers = !props.seenAt && props.hasMuted;

  if (shouldShowUnreadForSubscribers || shouldShowUnreadForNonsubscribers) {
    return <Trans id="invite-unread">Unread</Trans>;
  }

  if (props.hasSnoozed) {
    return <Trans id="invite-readandsnoozed">Read &amp; Snoozed</Trans>;
  }

  // We only show "Mute & Archive" for subscribers who haven't muted.
  if (!props.hasMuted && props.hasArchived) {
    return <Trans id="invite-readandarchived">Read &amp; Archived</Trans>;
  }

  if (isReadingNow(props.seenAt)) {
    return <Trans id="invite-readingnow">Reading now</Trans>;
  }

  const relativeSeenAtTime = (
    <RelativeDateTimeFormatter value={props.seenAt || 0} format={RelativeDateTimeFormatsEnum.SHORT} />
  );
  return <Trans id="invite-readtimeago">Read {relativeSeenAtTime} ago</Trans>;
};

/*
 * Helpers.
 */

function isReadingNow(seenAt?: number) {
  if (isUndefined(seenAt)) {
    return false;
  }

  const ellapsedSince = DateTime.fromMillis(seenAt).diffNow();
  return Math.abs(ellapsedSince.valueOf()) < Duration.fromObject({minutes: 3}).valueOf();
}
